import { ADVICE_NAMES, Advice } from "Store/advice/interfaces";
import {
  useAdviceDetailsFormValues,
  useAdviceResult,
} from "../hooks/stateSelectors";
import { getAdvicesAllowed, sortProducts } from "../utils";

import { useIsAdvisorSelector } from "Store/advisor/advisorSelectors";
import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { TextLanguage } from "Store/texts/interfaces";
import { isDefined } from "Utils/functions";
import { FormikProps } from "formik";
import React from "react";
import { AdviceProductDetailsFormValues } from "../../ProductDetails/FormElements/interfaces";
import { AdviceFeedback } from "../../adviceStyled";
import { AdviceCards } from "../AdviceCards";
import { AdvicePriceFormValues } from "../AdviceCards/interfaces";
import { AdviceDiffMessage } from "../AdviceMessages/AdviceDiff/AdviceDiffMessage";
import { AdviceScreenshot } from "../AdviceScreenshot/AdviceScreenshot";
import { useEntrance } from "../hooks/useEntrance";
import { AdviceComment } from "./AdviceComment";
import { AdviceIntro } from "./AdviceIntro";
import { AdviceTotalPriceCard } from "./AdviceTotalPriceCard";

const insurances: {
  name: ADVICE_NAMES;
  title: string;
}[] = [
  {
    name: INSURANCE_NAME_VALUE.DEATH,
    title: "death",
  },
  {
    name: INSURANCE_NAME_VALUE.DISABILITY_FLEX,
    title: "disability",
  },
  {
    name: INSURANCE_NAME_VALUE.CRITICAL_ILLNESS,
    title: "criticalIllness",
  },
];

interface Props {
  formProps: FormikProps<AdvicePriceFormValues>;
  formText: any;
  lang: TextLanguage;
  adviceScreenshot: AdviceScreenshot;
  handleTakeScreenshot: (formProps: AdvicePriceFormValues) => void;
}

export const AdviceForm = ({
  formProps,
  formText,
  lang,
  adviceScreenshot,
  handleTakeScreenshot,
}: Props): React.ReactElement => {
  const entrance = useEntrance();
  const isAdvisor = useIsAdvisorSelector();
  const adviceResult = useAdviceResult() as Advice;
  const adviceDetails =
    useAdviceDetailsFormValues() as AdviceProductDetailsFormValues;

  const weights = !isDefined(entrance) ? {} : { [entrance]: 0.1 };
  const sortedInsurance = sortProducts(insurances, weights);
  const listOfAllowedAdvices = getAdvicesAllowed(adviceResult);
  const advicesNotAllowed = listOfAllowedAdvices.length === 0;

  return (
    <div ref={adviceScreenshot.screenshotRefCallback}>
      <AdviceIntro
        sortedInsurance={sortedInsurance}
        formText={formText}
        lang={lang}
      />
      <AdviceCards
        formProps={formProps}
        adviceProductDetailsFormValues={adviceDetails}
        addedWeights={weights}
      />
      {isAdvisor && (
        <AdviceComment formProps={formProps} formText={formText} lang={lang} />
      )}
      {!advicesNotAllowed && (
        <>
          <AdviceFeedback id="adviceFeedback"></AdviceFeedback>
          <AdviceDiffMessage
            insurances={sortedInsurance}
            adviceMessagesText={formText.advice}
            lang={lang}
            formProps={formProps}
            handleTakeScreenshot={handleTakeScreenshot}
            screenshotIsLoading={adviceScreenshot.screenshotIsLoading}
            advicesNotAllowed={advicesNotAllowed}
          />
        </>
      )}
      <AdviceTotalPriceCard formProps={formProps} />
    </div>
  );
};
